import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Form, InputGroup, Nav, Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { deleteOrderItem, downloadBulkOrderInvoice, downloadOrdersExcelSheet, getCompletedOrdersListing, getOrdersListing, getRejectedOrdersListing } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import orderexchange from '../../assets/images/order-exchange.png';
import orderreturn from '../../assets/images/order-return.png';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import Select from 'react-select'
import { useFormik } from 'formik'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { orderListFilter } from '../../atoms/orderListFilter';
import { useRecoilState } from 'recoil';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SelectionContext } from '../../Context/Store';
import toast from 'react-hot-toast';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { FaDownload, FaFile, FaJediOrder } from "react-icons/fa6";
import { getBrandListing } from "../../api/context/brand";
import BulkInvoiceModal from './BulkOrderInvoice';
import { getManufacturesListingPaginate } from '../../api/context/manufacturer';
import { FiDownload, FiFile } from 'react-icons/fi';

// Extend dayjs with the plugins
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);


const queueDatatableCustomStyles = {
  headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '14px',
      padding: '16px 8px',
      backgroundColor: '#f9f9f9ff',
    },
  },
  cells: {
    style: {
      display: "flex",
      // justifyContent: "center",
      fontSize: '12px',
      fontWeight: '500',
      padding: '12px',
      zIndex: '5',
      cursor: "pointer"
    },
  },

};


const Orders = () => {

  const navigate = useNavigate()

  const { ordersTrigger, setOrdersTrigger } = useContext(SelectionContext)

  const [filterData, setFilterdata] = useRecoilState(orderListFilter);
  // const [page, setPage] = useRecoilState(orderListPage);
  // const [limit, setLimit] = useRecoilState(orderListLimit);

  const [orders, setOrders] = useState([]);
  // const [completedorders, setCompletedOrders] = useState([]);
  // const [rejectedorders, setRejectedOrders] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  // const [totalActiveRows, setTotalActiveRows] = useState(0);
  // const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [limitactive, setLimitActive] = useState(10);
  const [pageactive, setPageActive] = useState(1);
  const [limitinactive, setLimitInactive] = useState(10);
  const [pageinactive, setPageInactive] = useState(1);
  const [update, setUpdate] = useState(false);
  const [initial, setInitial] = useState(false);

  const [showFilters, setShowFilters] = useState(false);

  const [modal, setModal] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [filter, setFilter] = useState("all");
  const [show, setShow] = useState(false);
  const [checkoutErrorShown, setCheckoutErrorShown] = useState(false);
  const [downloadOrdersExcel, setDownloadOrdersExcel] = useState(false);
  const [totalOrdesToDownload, setTotalOrdersToDownload] = useState([]);
  const [limitDownloadOrders, setLimitDownloadOrders] = useState(5);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const typingRef = useRef(null);

  const [brands, setBrands] = useState([]);
  const [pageBrands, setPageBrands] = useState(1);
  const [hasMoreBrands, setHasMoreBrands] = useState(true);
  const [brandSearch, setBrandSearch] = useState('');

  const [hasMore, setHasMore] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowFilters = () => setShowFilters(true);
  const handleCloseFilters = () => setShowFilters(false);

  const [bulkInvoiceModal, setBulkInvoiceModal] = useState(false);
  const [bulkVendors, setBulkVendors] = useState([]);
  const [bulkStartDate, setBulkStartDate] = useState(null);
  const [bulkEndDate, setBulkEndDate] = useState(null);
  const [downloadingBulkInvoice, setDownloadingBulkInvoice] = useState(false);
  const [manufacturers, setManufacturers] = useState([]);
  const [hasMoreManufacture, setHasMoreManufacture] = useState(true);



  const orderTypeOptions = [
    { value: null, label: 'NEW' },
    { value: 1, label: 'RETURN' },
    { value: 2, label: 'EXCHANGE' }
  ]
  const orderStatusOptions = [
    { value: 'INITIATED', label: 'INITIATED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
    { value: 'CONFIRMED', label: 'CONFIRMED' },
    { value: 'DELIVERED', label: 'DELIVERED' },
    { value: 'REJECTED', label: 'REJECTED' }
  ]

  const paymentModeOptions = [
    { value: "COD", label: 'COD' },
    { value: "ONLINE", label: 'ONLINE' },
  ]

  const paymentStatusOptions = [
    { value: "PENDING", label: 'PENDING' },
    { value: "DONE", label: 'DONE' },
  ]

  const columns = [
    {
      name: "S. No.",
      selector: (row, index) => {
        if (filter === "all") {
          return page * limit - limit + (index + 1);
        } else if (filter === "completed") {
          return pageactive * limitactive - limitactive + (index + 1);
        } else if (filter === "rejected") {
          return pageinactive * limitinactive - limitinactive + (index + 1);
        } else {
          return page * limit - limit + (index + 1);
        }
      },
      width: "90px",
      center: true,
    },
    {
      id: 'orderId',
      name: 'Order Id',
      selector: (row) => row?.orderId,
      cell: (row) => (
        <Tooltip title={row?.orderId} disableInteractive placement='top'>
          <div
            className="related-order-box"
            style={{
              backgroundColor: 'rgba(70, 70, 70, 0.1)' // 50% transparent
              ,
              color: 'black',
              padding: '4px 8px',
              borderRadius: '4px',
              fontWeight: '500',
              cursor: 'pointer',
              minWidth: '80px',
              textAlign: 'center',
              margin: '2px'
            }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/orderdetails/${row.id}`);
            }}
          >
            {row?.orderId}
          </div>
        </Tooltip>

      ),

      grow: 0.5,
      minWidth: '170px',
      center: true, // Added
    },

    {
      name: "Order Status",
      headerClassName: "text-center",
      cell: (row) => {
        const status = row?.status;
        let bgColor = '';
        let textColor = 'white';

        // Set colors based on status
        switch (status) {
          case "CANCELLED":
            bgColor = '#dc3545'; // Red
            break;
          case "INITIATED":
            bgColor = '#ffc107'; // Yellow (warning)
            textColor = '#212529'; // Dark text for better contrast
            break;
          case "CONFIRMED":
            bgColor = '#17a2b8'; // Teal
            break;
          case "DELIVERED":
            bgColor = '#28a745'; // Green
            break;
          case "REJECTED":
            bgColor = '#dc3545';// Red
            break;
          default:
            bgColor = '#6f42c1'; // Purple (fallback)
        }

        return (
          <div className="text-capitalize">
            {status ? (
              <span
                style={{
                  backgroundColor: bgColor,
                  color: textColor,
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontWeight: '500'
                }}
              >
                {status.toLowerCase().split('_').map(word =>
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </span>
            ) : (
              'N/A'
            )}
          </div>
        );
      },
      sortable: true,
      center: true,
      minWidth: '120px',
      selector: (row) => row.status, // Keep for sorting
    },
    {
      id: 'createdAt',
      name: 'Date',
      selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
            <div className='text-truncate'>{moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')}</div>
          </Tooltip>
        </div>
      ),
      grow: 0.5,
      minWidth: '150px',
      center: true,
    },
    {
      id: 'orderType',
      name: 'Order Type',
      selector: (row) => row?.orderType,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.orderType === 3 ? "Delivered" : row?.orderType === 2 ? "Exchange" : row?.orderType === 1 ? "Return" : "New"} disableInteractive placement='top'>
            <div className={`${row?.orderType == null ? "gradient-border" : "gradient-border"}`}>
              <div className='text-truncate'>
                {row?.orderType === 3 && <img className='order-new' src={ordernew} alt='Order New' />}
                {row?.orderType === 2 && <img className='order-new' src={orderexchange} alt='Order Exchange' />}
                {row?.orderType === 1 && <img className='order-new' src={orderreturn} alt='Order Return' />}
                {row?.orderType == null && <img className='order-new' src={ordernew} alt='Order New' />}
                {row?.orderType === 3 ? "Delivered" : row?.orderType === 2 ? "Exchange" : row?.orderType === 1 ? "Return" : "New"}
              </div>
            </div>
          </Tooltip>
        </div>
      ),
      center: true,
      grow: 0.3,
      minWidth: '170px',
    },
    {
      id: 'amount',
      name: 'Amount',
      selector: (row) => userType === 'ADMIN' ? row?.amount : row?.billingAmount,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={userType === 'ADMIN' ? row?.amount : row?.billingAmount} disableInteractive placement='top'>
            <div className='text-truncate'>{userType === 'ADMIN' ? row?.amount : row?.billingAmount}</div>
          </Tooltip>
        </div>
      ),
      center: true,
      grow: 0.5,
      minWidth: '90px',
    },
    {
      name: 'Return Id',
      cell: (row) => {
        let returnIds = [];

        if (row.returnIdForVedor) {
          if (typeof row.returnIdForVedor === 'string') {
            returnIds = row.returnIdForVedor.split(',').map(id => id.trim());
          } else if (Array.isArray(row.returnIdForVedor)) {
            returnIds = row.returnIdForVedor;
          }
        }

        return (
          <div className="d-flex justify-content-center flex-wrap gap-1">
            {returnIds.length > 0 ? (
              returnIds.map((id, index) => (
                <Tooltip
                  key={`return-${id}-${index}`}
                  title={`View Return Order: ${id}`}
                  disableInteractive
                  placement="top"
                >
                  <span
                    style={{
                      color: 'red',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontWeight: '600',
                      margin: '2px',
                      fontSize: '14px'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/orderdetails/${id}`);
                    }}
                  >
                    {id}
                  </span>
                </Tooltip>
              ))
            ) : (
              <div className="text-truncate">-</div>
            )}
          </div>
        );
      },
      center: true,
      minWidth: '150px',
      ignoreRowClick: true,
    },
    {
      name: 'Exchange Id',
      cell: (row) => {
        let exchangeIds = [];

        if (row.exchangeIdForVedor) {
          if (typeof row.exchangeIdForVedor === 'string') {
            exchangeIds = row.exchangeIdForVedor.split(',').map(id => id.trim());
          } else if (Array.isArray(row.exchangeIdForVedor)) {
            exchangeIds = row.exchangeIdForVedor;
          }
        }

        return (
          <div className="d-flex justify-content-center flex-wrap gap-1">
            {exchangeIds.length > 0 ? (
              exchangeIds.map((id, index) => (
                <Tooltip
                  key={`exchange-${id}-${index}`}
                  title={`View Exchange Order: ${id}`}
                  disableInteractive
                  placement="top"
                >
                  <span
                    style={{
                      color: '#0b6a93ff',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontWeight: '600',
                      margin: '2px',
                      fontSize: '14px'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/orderdetails/${id}`);
                    }}
                  >
                    {id}
                  </span>
                </Tooltip>
              ))
            ) : (
              <div className="text-truncate">-</div>
            )}
          </div>
        );
      },
      center: true,
      minWidth: '150px',
      ignoreRowClick: true,
    },


    {
      name: "Payment Status",
      cell: (row) => {
        const status = row?.paymentStatus;
        let bgColor = '';
        let textColor = 'white';

        if (status === "DONE") {
          bgColor = '#28a745'; // Green for completed
        } else {
          bgColor = '#dc7235ff'; // Red for pending
        }

        return (
          <div className="text-capitalize">
            {status ? (
              <span
                style={{
                  backgroundColor: bgColor,
                  color: textColor,
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontWeight: '500'
                }}
              >
                {status === "DONE" ? "Completed" : "Pending"}
              </span>
            ) : (
              'N/A'
            )}
          </div>
        );
      },
      center: true,
      minWidth: '180px',
      sortable: true,
    },
  ];

  const conditionalRowStyles = [

    {
      when: row => row.returnIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
        '&:hover': {
          backgroundColor: 'rgba(238, 145, 155, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(0, 140, 255, 0.1)', // Very light blue
        '&:hover': {
          backgroundColor: 'rgba(0, 140, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.returnIdForVedor !== null && row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(180, 120, 255, 0.1)', // Light purple
        '&:hover': {
          backgroundColor: 'rgba(180, 120, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
  ];






  const searchFormik = useFormik({
    initialValues: {
      startDate: filterData.startDate || '',
      endDate: filterData.endDate || '',
      orderType: filterData.orderType || '',
      selected_orderType: filterData.selected_orderType || '',
      orderStatus: filterData.orderStatus || '',
      selected_orderStatus: filterData.selected_orderStatus || '',
      selected_orderType: filterData.selected_orderType || '',
      paymentMode: filterData.paymentMode || '',
      selected_paymentMode: filterData.selected_paymentMode || '',
      paymentStatus: filterData.paymentStatus || '',
      selected_paymentStatus: filterData.selected_paymentStatus || '',
      brands: filterData.brands || [],
      selected_brands: filterData.selected_brands || []
    },
    validate: async (values) => {
      // Add validation logic if needed
    },
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      setFilterdata(values);
      setShow(false);
    },
  });

  const exportOrdersToExcel = async (filter) => {
    setDownloadOrdersExcel(true);

    try {
      // 🔹 Build same params as fetchOrdersData
      const params = filterData ? { ...filterData, page, limit, search } : { page, limit, search };

      if (filter === "completed") {
        params.status = "CONFIRMED";
      }
      if (filter === "rejected") {
        params.status = "REJECTED";
      }
      if (filter === "cancelled") {
        params.status = "CANCELLED";
      }

      // 🔹 Call backend
      const response = await downloadOrdersExcelSheet(params);

      if (response?.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `orders_export_${new Date().toISOString().split("T")[0]}.xlsx`
        ); // dynamic file name
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error("Error exporting orders to Excel:", error);
    } finally {
      setDownloadOrdersExcel(false);
    }
  };


  // const handleMenuScrollToBottomBrands = () => {
  //   if (!hasMoreBrands) return;
  //   const nextPage = pageBrands + 1;
  //   fetchBrands(brandSearch, nextPage).then(() => {
  //     setPageBrands(nextPage);
  //   });
  // };

  // const handleBrandInputChange = (newValue, { action }) => {
  //   if (action === 'input-change') {
  //     setPageBrands(1);
  //     setHasMoreBrands(true);
  //   }
  //   return newValue;
  // };

  const handleBulkInvoiceDownload = async () => {
    if (!bulkStartDate || !bulkEndDate) {
      toast.error("Please select date range");
      return;
    }

    if (userType=='ADMIN' && !bulkVendors.length) {
      toast.error("Please select vendors");
      return;
    }

    try {
      setDownloadingBulkInvoice(true);

      const payload = {
        startDate: dayjs(bulkStartDate).format("YYYY-MM-DD"),
        endDate: dayjs(bulkEndDate).format("YYYY-MM-DD"),
      };

      // ✅ Only ADMIN sends vendorIds
      if (userType === 'ADMIN') {
        payload.vendorIds = bulkVendors.map(v => v.value);
      }

      const response = await downloadBulkOrderInvoice(payload);

      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `vendor_invoices_${payload.startDate}_${payload.endDate}.zip`
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      setBulkInvoiceModal(false);
    } catch (error) {
      console.error("Bulk invoice download failed:", error);
      toast.error("Failed to download invoices");
    } finally {
      setDownloadingBulkInvoice(false);
    }
  };


  const fetchManufacturers = (inputValue = "", currentPage = 1, limit = 100) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(() => {
        getManufacturesListingPaginate({
          page: currentPage,
          limit,
          search: inputValue
        })((response) => {
          if (response?.statusCode === 200) {
            const results = response.results.map(item => ({
              value: item.value,   // ✅ correct
              label: item.label,   // ✅ correct
            }));

            setManufacturers(results);
            setHasMoreManufacture(results.length > 0);
            resolve(results);
          } else {
            setManufacturers([]);
            setHasMoreManufacture(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };



  const fetchAllOrderData = async (filter) => {
    let limit = limitDownloadOrders;
    const params = filterData ? { ...filterData, page, limit, search } : { page, limit, search };

    if (filter === 'completed') {
      params.status = 'CONFIRMED';
    }

    if (filter === 'rejected') {
      params.status = 'REJECTED';
    }

    if (filter === 'cancelled') {
      params.status = 'CANCELLED';
    }

    delete params.orderStatus;
    delete params.selected_orderStatus;
    delete params.selected_paymentMode;
    delete params.selected_paymentStatus;
    delete params.selected_orderType;


    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        setTotalOrdersToDownload(response?.data?.orders);
        setLimitDownloadOrders(response?.data?.totalItems);
        setLoading(false);
      } else {
        setTotalOrdersToDownload([]);
        setLimitDownloadOrders(5);
        setLoading(false);
      }
    });

  }; let typingTimer;

  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      console.log("Brand API params:", { page: currentPage, pageSize: limit, search: inputValue });

      typingTimer = setTimeout(() => {
        getBrandListing({ page: currentPage, pageSize: limit, search: inputValue })(response => {
          console.log("Brand API response:", response);
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            if (currentPage === 1) {
              setBrands(results);
            } else {
              setBrands((prevBrands) => [...prevBrands, ...results]);
            }

            setHasMore(results.length > 0);
            resolve(results);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };


  // const loadOptionsBrands = (inputValue) => {
  //   return fetchBrands(inputValue, 1).then((options) => {
  //     console.log("Options loaded:", options);
  //     return options;
  //   });
  // };
  // const handleMenuScrollToBottom = () => {
  //   if (hasMore) {
  //     const nextPage = pageBrands + 1;   // ✅ use pageBrands, not pagebrands
  //     fetchBrands(searchFormik.values.selected_brands?.label || '', nextPage).then(() => {
  //       setPageBrands(nextPage);
  //     });
  //   }
  // };

  const fetchOrdersData = async (filter) => {


    const params = filterData ? { ...filterData, page, limit, search } : { page, limit, search };

    if (filter === 'completed') {
      params.status = 'CONFIRMED';
    }

    if (filter === 'rejected') {
      params.status = 'REJECTED';
    }

    if (filter === 'cancelled') {
      params.status = 'CANCELLED';
    }

    if (!params.status && params.orderStatus) {
      params.status = params.orderStatus;
    }


    delete params.orderStatus;
    delete params.selected_orderStatus;
    delete params.selected_paymentMode;
    delete params.selected_paymentStatus;
    delete params.selected_orderType;
    delete params.selected_brands;

    if (params.brands && params.brands.length > 0) {
      params.brandIds = params.brands;                 // array version
      params.brand_id = params.brands[0];              // single ID (just in case)
      params.brandsCSV = params.brands.join(",");      // CSV string version
    }
    console.log('Final API params:', params);

    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        setOrders(response?.data?.orders);
        setTotalRows(response?.data?.totalItems);
        setLoading(false);
      } else {
        setOrders([]);
        setLoading(false);
      }
    });
  };


  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setPage(1);
    setUpdate(!update);
  };

  const handlePageChange = (page) => {
    setPage(page);
    setUpdate(!update);
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  // const handleConfirm = (deletingId) => {
  //   setModal(!modal);
  //   setDeletingId(deletingId);
  // };

  const deleteOrder = (id) => {
    deleteOrderItem(id)((response) => {
      if (response?.request?.status == 200) {
        setUpdate(!update);
        setModal(!modal);
      } else {
      }
    });
    // });
  };


  // const handleFilterChange = (newFilter) => {
  //   console.log('Filter changed to:', newFilter);
  //   setPage(1);
  //   setFilter(newFilter);

  //   searchFormik.setValues({
  //     ...searchFormik.values,
  //     orderStatus: "",
  //     selected_orderStatus: ""
  //   });
  // };


  // const handlePerRowsActiveChange = (newPerPage, page) => {
  //   setLimitActive(newPerPage);
  //   setPageActive(1);
  //   setUpdate(!update);
  // };

  // const handlePerRowsInactiveChange = (newPerPage, page) => {
  //   setLimitInactive(newPerPage);
  //   setPageInactive(1);
  //   setUpdate(!update);
  // };

  // const handlePageActiveChange = (page) => {
  //   setPageActive(page);
  //   setUpdate(!update);
  // };

  // const handlePageInactiveChange = (page) => {
  //   setPageInactive(page);
  //   setUpdate(!update);
  // };

  const applyFilters = (partial) => {
    const next = { ...searchFormik.values, ...partial };

    // Update UI form state
    searchFormik.setValues(next);

    // Push to recoil (your useEffect listens to filterData)
    setFilterdata(next);

    // UX: reset to first page + show loader
    setPage(1);
    setLoading(true);

    // If you rely on 'update' elsewhere and want to force refresh, uncomment:
    // setUpdate(u => !u);
  };

  const onOrderTypeChange = (selectedOption) => {
    applyFilters({
      orderType: selectedOption ? selectedOption.value : null,
      selected_orderType: selectedOption || null
    });

  }

  // FIXED: Corrected the typo here
  const onOrderStatusChange = (selectedOption) => {
    setFilter("all");
    applyFilters({
      orderStatus: selectedOption?.value || "",
      selected_orderStatus: selectedOption || ""
    });
  }

  const onpaymentModeChange = (selectedOption) => {
    applyFilters({
      paymentMode: selectedOption?.value || "",
      selected_paymentMode: selectedOption || ""
    });
  }

  const onpaymentStatusChange = (selectedOption) => {
    applyFilters({
      paymentStatus: selectedOption?.value || "",
      selected_paymentStatus: selectedOption || ""
    });
  }

  const onBrandChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      brands: selectedValues,
      selected_brands: selectedOptions || [],
    });
  }

  const handleReset = () => {
    searchFormik.resetForm({
      values: {
        startDate: "",
        endDate: '',
        orderType: null,
        selected_orderType: "",
        orderStatus: "",
        selected_orderStatus: "",
        paymentMode: "",
        selected_paymentMode: "",
        paymentStatus: "",
        selected_paymentStatus: "",
        brands: [],
        selected_brands: []
      }
    });
    setFilterdata({
      startDate: "",
      endDate: '',
      orderType: null,
      selected_orderType: "",
      orderStatus: "",
      selected_orderStatus: "",
      paymentMode: "",
      selected_paymentMode: "",
      paymentStatus: "",
      selected_paymentStatus: "",
      brands: [],
      selected_brands: []
    });
    setSearch('');
    setShow(false);
    setUpdate(!update);
  };


  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (isFilterApplied) {
      searchFormik.handleSubmit(e);
    } else {
      handleReset();
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchOrdersData(filter);
    setIsInitialRender(false);
  }, [update, filter, filterData]);

  useEffect(() => {
    if (isInitialRender) return;
    setLoading(true);
    fetchAllOrderData(filter)
  }, [update, filter, filterData, limitDownloadOrders]);

  useEffect(() => {
    fetchManufacturers("", 1, 100);
  }, []);


  useEffect(() => {
    if (ordersTrigger) {
      fetchOrdersData(filter);
      setOrdersTrigger(false);
    }
  }, [ordersTrigger]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) setUpdate(!update);
      else setInitial(!initial);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);
  useEffect(() => {
    getBrandListing({ page: 1, pageSize: 100, search: "" })((response) => {
      if (response?.statusCode === 200) {
        setBrands(
          (response?.data || []).map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      } else {
        setBrands([]);
      }
    });
  }, []);

  const isFilterApplied = !!(
    searchFormik.values.startDate ||
    searchFormik.values.endDate ||
    searchFormik.values.orderType ||
    searchFormik.values.orderStatus ||
    searchFormik.values.paymentMode ||
    searchFormik.values.paymentStatus ||
    (searchFormik.values.brands && searchFormik.values.brands.length > 0)
  );

  const userType = JSON.parse(localStorage.getItem('user'))?.userType;

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-stretch mb-3 mt-2">
            <div className="d-flex align-items-center">
              <h3 className="mb-0 fw-bolder">Orders</h3>
            </div>

            <div className="d-flex align-items-center pe-0 gap-2">

              <div
                className="request_btn custom-rounded-btn ms-2"
                onClick={() => setBulkInvoiceModal(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <FiFile />
                <span>Download Bulk Invoice</span>
              </div>



              {userType !== 'customerSupport' && (
                <div className="d-flex align-items-center">
                  <div
                    className='request_btn custom-rounded-btn'
                    onClick={() => exportOrdersToExcel()}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      cursor: 'pointer'
                    }}
                  >
                    {downloadOrdersExcel ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span>Exporting...</span>
                      </>
                    ) : (
                      <>
                        <FiDownload />
                        <span>Export orders</span>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Box
        sx={{
          pb: 3,
          display: "flex",
          gap: 2,
          minWidth: "100%",

        }}
      >
        <Form onSubmit={handleFilterSubmit} style={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "24px", // Adjusted gap for better spacing
              width: "100%",


            }}
          >
            <Box
              sx={{
                flex: "0 0 200px",              // fixed width
                position: "sticky",
                left: 0,
                zIndex: 2,                      // above the scrolling strip
                backgroundColor: "#fff",        // match page background so it doesn’t show overlap
              }}
            ><Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Search</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control"
                  placeholder="search for orders ..."
                  onChange={(e) => setSearch(e.target.value.trim())}
                  style={{
                    minHeight: "35px",
                    fontSize: "1vmax",
                    borderRadius: "6px",
                    lineHeight: "2",
                    padding: "2px 8px",
                  }}
                />
              </Form.Group>
            </Box>
            {/* Order Type */}
            <Box
              sx={{
                flex: "1 1 150px",
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: "24px",
                paddingTop: "0.5px",
                overflowX: "auto",
                overflowY: "hidden",
                // hide scrollbar cross-browser
                "::-webkit-scrollbar": { display: "none" },
                msOverflowStyle: "none",
                scrollbarWidth: "none",

                // make each field a fixed tile
                "& .filter-field": {
                  flex: "0 0 150px",
                },
              }}
            >
              <Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Order Type</Form.Label>
                <Select
                  placeholder="Select "
                  options={orderTypeOptions}
                  value={searchFormik.values.selected_orderType}
                  onChange={onOrderTypeChange}
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      minHeight: 30,
                      fontSize: "1vmax"
                    }),
                    input: (base) => ({ ...base, fontSize: "1vmax" }),
                    singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                  }}
                  theme={(t) => ({
                    ...t,
                    spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                  })}
                />
              </Form.Group>
              {/* Order Status */}
              <Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Order Status</Form.Label>
                <Select
                  placeholder="Select"
                  options={orderStatusOptions}
                  value={searchFormik.values.selected_orderStatus}
                  onChange={onOrderStatusChange}
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      minHeight: 30,
                      fontSize: "1vmax"
                    }),
                    input: (base) => ({ ...base, fontSize: "1vmax" }),
                    singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                  }}
                  theme={(t) => ({
                    ...t,
                    spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                  })}
                />
              </Form.Group>

              {/* Payment Mode */}
              <Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Payment Mode</Form.Label>
                <Select
                  placeholder="Select"
                  options={paymentModeOptions}
                  value={searchFormik.values.selected_paymentMode}
                  onChange={onpaymentModeChange}
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      minHeight: 30,
                      fontSize: "1vmax"
                    }),
                    input: (base) => ({ ...base, fontSize: "1vmax" }),
                    singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                  }}
                  theme={(t) => ({
                    ...t,
                    spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                  })}
                />
              </Form.Group>

              {/* <Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Brands</Form.Label>
                <AsyncSelect
                  isMulti
                  cacheOptions
                  defaultOptions
                  loadOptions={(inputValue, callback) => {
                    getBrandListing({ page: 1, pageSize: 20, search: inputValue })((response) => {
                      if (response?.statusCode === 200) {
                        const results = response?.data?.map(item => ({
                          value: item.id,
                          label: item.name,
                        }));
                        callback(results);
                      } else {
                        callback([]);
                      }
                    });
                  }}
                  placeholder="Select"
                  onChange={onBrandChange}
                  value={searchFormik.values.selected_brands}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({ ...base, minHeight: 30, fontSize: "1vmax" }),
                    input: (base) => ({ ...base, fontSize: "1vmax" }),
                    singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                  }}
                  theme={(t) => ({
                    ...t,
                    spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                  })}
                  menuPortalTarget={document.body}
                />
              </Form.Group> */}

              {/* Payment Status */}
              <Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Payment Status</Form.Label>
                <Select
                  placeholder="Select"
                  options={paymentStatusOptions}
                  value={searchFormik.values.selected_paymentStatus}
                  onChange={onpaymentStatusChange}
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      minHeight: 30,
                      fontSize: "1vmax"
                    }),
                    input: (base) => ({ ...base, fontSize: "1vmax" }),
                    singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                  }}
                  theme={(t) => ({
                    ...t,
                    spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                  })}
                />
              </Form.Group>
              {/* Start Date */}
              <Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Start Date</Form.Label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="startDate"
                    value={dayjs(searchFormik.values.startDate)}
                    onChange={(newValue) => {
                      const d = dayjs(newValue);
                      if (d.isValid()) {
                        const ymd = d.format("YYYY-MM-DD");
                        // auto-apply: set both to same day initially
                        applyFilters({ startDate: ymd, endDate: ymd });
                      } else {
                        applyFilters({ startDate: "", endDate: "" });
                      }
                    }}
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        size: "small",
                        error: false,
                        sx: {
                          width: "100%",
                          "& .MuiInputBase-root": { height: 35 },
                          "& .MuiInputBase-input": { fontSize: "1vmax" }
                        }
                      }
                    }}
                  />
                </LocalizationProvider>
              </Form.Group>

              {/* End Date */}
              <Form.Group className="filter-field">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>End Date</Form.Label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="endDate"
                    value={dayjs(searchFormik.values.endDate)}
                    onChange={(newValue) => {
                      const d = dayjs(newValue);
                      const start = dayjs(searchFormik.values.startDate);

                      if (d.isValid() && (!start.isValid() || d.isSameOrAfter(start))) {
                        applyFilters({ endDate: d.format("YYYY-MM-DD") });
                        setCheckoutErrorShown(false);
                      } else {
                        if (!checkoutErrorShown) {
                          toast.error("From date must be less than or equal to to date", { className: "loginToaster" });
                          setCheckoutErrorShown(true);
                        }
                        applyFilters({ endDate: "" });
                      }
                    }}
                    minDate={searchFormik.values.startDate ? dayjs(searchFormik.values.startDate) : undefined}
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        size: "small",
                        error: false,
                        sx: {
                          width: "100%",
                          "& .MuiInputBase-root": { height: 35 },
                          "& .MuiInputBase-input": { fontSize: "1vmax" }
                        }
                      }
                    }}
                  />


                </LocalizationProvider>
              </Form.Group>
              <div style={{ paddingTop: "25px", height: "40px" }} >
                <Button variant="outlined" className='cancel_btn' onClick={handleReset}
                  style={{          // keeps text vertically centered
                    fontSize: "12px"
                  }}
                > Reset
                </Button>
              </div>

            </Box>

          </Box>
        </Form>

      </Box>

      <div className='col-12'>
        {filter == "all" && (
          <Box className="products-and-options" sx={{ mt: 1 }}>
            <Paper square className='shadow-none border border-blue-grey-200'>
              <div>
                <DataTable
                  columns={columns}
                  conditionalRowStyles={conditionalRowStyles}
                  data={orders}
                  progressPending={loading}
                  progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={limit}
                  onRowClicked={(row) => navigate('/orderdetails/' + row?.id)}
                  onChangeRowsPerPage={handlePerRowsChange}
                  pointerOnHover // Adds cursor pointer on hover
                  highlightOnHover // Adds hover effect
                  paginationRowsPerPageOptions={[10, 50, 100, 150]}
                  onChangePage={handlePageChange}
                  currentPage={page}
                  customStyles={queueDatatableCustomStyles}
                />
              </div>
            </Paper>
          </Box>
        )}
        {filter == "completed" && (
          <Box className="products-and-options" sx={{ mt: 1 }}>
            <Paper square>
              <div>
                <DataTable
                  columns={columns}
                  data={orders}
                  progressPending={loading}
                  progressComponent={
                    <div style={{ height: "60vh" }}>
                      <Loader />
                    </div>
                  }
                  pagination
                  paginationServer
                  pointerOnHover // Adds cursor pointer on hover
                  highlightOnHover // Adds hover effect
                  paginationTotalRows={totalRows}
                  paginationPerPage={limit}
                  onRowClicked={(row) => navigate('/orderdetails/' + row?.id)}
                  onChangeRowsPerPage={handlePerRowsChange}
                  paginationRowsPerPageOptions={[10, 50, 100, 150]}
                  onChangePage={handlePageChange}
                  currentPage={page}
                  customStyles={queueDatatableCustomStyles}
                />
              </div>
            </Paper>
          </Box>
        )}
        {filter == "rejected" && (
          <Box className="products-and-options" sx={{ mt: 1 }}>
            <Paper square>
              <div>
                <DataTable
                  columns={columns}
                  data={orders}
                  progressPending={loading}
                  progressComponent={
                    <div style={{ height: "60vh" }}>
                      <Loader />
                    </div>
                  }
                  pagination
                  paginationServer
                  pointerOnHover // Adds cursor pointer on hover
                  highlightOnHover // Adds hover effect
                  paginationTotalRows={totalRows}
                  paginationPerPage={limit}
                  onRowClicked={(row) => navigate('/orderdetails/' + row?.id)}
                  onChangeRowsPerPage={handlePerRowsChange}
                  paginationRowsPerPageOptions={[10, 50, 100, 150]}
                  onChangePage={handlePageChange}
                  currentPage={page}
                  customStyles={queueDatatableCustomStyles}
                />
              </div>
            </Paper>
          </Box>
        )}
        {filter == "cancelled" && (
          <Box className="products-and-options" sx={{ mt: 1 }}>
            <Paper square>
              <div>
                <DataTable
                  columns={columns}
                  data={orders}
                  progressPending={loading}
                  progressComponent={
                    <div style={{ height: "60vh" }}>
                      <Loader />
                    </div>
                  }
                  pagination
                  paginationServer
                  pointerOnHover // Adds cursor pointer on hover
                  highlightOnHover // Adds hover effect
                  paginationTotalRows={totalRows}
                  paginationPerPage={limit}
                  onRowClicked={(row) => navigate('/orderdetails/' + row?.id)}
                  onChangeRowsPerPage={handlePerRowsChange}
                  paginationRowsPerPageOptions={[10, 50, 100, 150]}
                  onChangePage={handlePageChange}
                  currentPage={page}
                  customStyles={queueDatatableCustomStyles}
                />
              </div>
            </Paper>
          </Box>
        )}
      </div>
      <CustomisedModal
        isOpen={modal}
        customClass={"policy_modal"}
        toggle={toggleModal}
      >
        <h5>Are you sure you want to remove this item?</h5>
        <div className="policy_Agree">
          <Button
            onClick={() => {
              setModal(!modal);
            }}
            size="lg"
            className="btn_cancel"
          >
            Cancel
          </Button>
          <Button
            size="lg"
            className="btn"
            onClick={() => deleteOrder(deletingId)}
          >
            Delete
          </Button>
        </div>
      </CustomisedModal>

      <BulkInvoiceModal
        open={bulkInvoiceModal}
        onClose={() => setBulkInvoiceModal(false)}
        vendors={manufacturers}          // vendor list
        selectedVendors={bulkVendors}
        setSelectedVendors={setBulkVendors}
        startDate={bulkStartDate}
        setStartDate={setBulkStartDate}
        endDate={bulkEndDate}
        setEndDate={setBulkEndDate}
        loading={downloadingBulkInvoice}
        onDownload={handleBulkInvoiceDownload}
      />

    </div>
  );
}


export default Orders